import { gql, useSubscription } from "@apollo/client";
import SearchableSelect from "./SearchableSelect";
import { AppAction } from "../App";

const mapListGql = gql`
subscription Collection_maps {
    maps {
        nodes {
            id
            name
            note
            rootNode
            accessPolicy
            # noteInline
            # defaultExpandDepth
            nodeAccessPolicy
            # featured
            # editors
            # creator
            # createdAt
            # edits
            # editedAt
            # extras
            # __typename
        }
        # __typename
    }
}
`;

export default function MapList({ client, id, dispatch, map }: {
    client: any,
    id: string,
    dispatch: React.Dispatch<AppAction>,
    map: any
}): JSX.Element {
    const { data } = useSubscription(mapListGql, {
        client: client
    });

    function setSelected(map: any) {
        dispatch({ map: map })
    }


    const maps = data?.maps?.nodes || [];

    return <>
        <SearchableSelect
            id={id}
            type='single'
            options={maps}
            optionlabel={'name'}
            setSelected={setSelected}
            selected={map}
            defaultIsOpen={false}
        />
    </>
}